import React from "react";
import layout from "./layouts"
import { useNavigate } from 'react-router-dom';


function renderLayout(config) {
  const {type, ...otherProps} = config ?? {}
  if (typeof layout[type] !== "undefined") {
    return React.createElement(
      layout[config.type],
      {...otherProps}
    );
  }
}

export default renderLayout;